module.exports = __webpack_public_path__ + "SLK.a6556dbc.png";